import { ReportState, ReportAction } from "./types";
import { initialState } from "./consts";
import actionTypes from "./actionTypes";

export default function reducer(
  state: ReportState,
  action: ReportAction
): ReportState {
  switch (action.type) {
    case actionTypes.SELECT_FUNCTION:
      return {
        ...state,
        selectedFunction: action.payload,
        currentStep: "items-list"
      };

    case actionTypes.ADD_ITEM: {
      const { fn, category } = action.payload;
      const existing = state.items[fn] || [];
      // Don't add duplicates
      if (existing.some((item) => item.category.id === category.id)) {
        return state;
      }
      return {
        ...state,
        items: {
          ...state.items,
          [fn]: [...existing, { category, totalQuantity: 1, groups: [] }]
        }
      };
    }

    case actionTypes.REMOVE_ITEM: {
      const { fn, categoryId } = action.payload;
      const existing = state.items[fn] || [];
      return {
        ...state,
        items: {
          ...state.items,
          [fn]: existing.filter((item) => item.category.id !== categoryId)
        }
      };
    }

    case actionTypes.UPDATE_ITEM_QUANTITY: {
      const { fn, categoryId, totalQuantity } = action.payload;
      const existing = state.items[fn] || [];
      return {
        ...state,
        items: {
          ...state.items,
          [fn]: existing.map((item) =>
            item.category.id === categoryId ? { ...item, totalQuantity } : item
          )
        }
      };
    }

    case actionTypes.UPDATE_ITEM_GROUPS: {
      const { fn, categoryId, groups } = action.payload;
      const existing = state.items[fn] || [];
      return {
        ...state,
        items: {
          ...state.items,
          [fn]: existing.map((item) =>
            item.category.id === categoryId ? { ...item, groups } : item
          )
        }
      };
    }

    case actionTypes.SET_STEP:
      return { ...state, currentStep: action.payload };

    case actionTypes.RESET:
      return initialState;

    default:
      return state;
  }
}
